import type { ContextState, FeaturesConfig, KeyOfContextToolState } from '../../../models'
import { CONTAINER } from '../../../config/inversify.config'
import { TYPES } from '../../../config/inversify.types'
import { FeatureIdEnum } from '../../../enums'

export function getStateToolKey(state: ContextState): KeyOfContextToolState {
  const persistentToolKeys: Array<KeyOfContextToolState> = [
    FeatureIdEnum.EXPLAIN,
    FeatureIdEnum.INSIGHTS,
    FeatureIdEnum.AUDIT,
  ]

  const parentId = CONTAINER.get<FeaturesConfig>(TYPES.FeaturesConfig)?.[state.domain]?.find(
    feature => feature.id === state.currentFeature,
  )?.parentId as KeyOfContextToolState

  if (parentId && persistentToolKeys.includes(parentId)) {
    return parentId
  }

  return persistentToolKeys.includes(state.currentFeature as KeyOfContextToolState)
    ? (state.currentFeature as KeyOfContextToolState)
    : 'tools'
}
